import { createTheme } from '@material-ui/core/styles';

const basicTheme = createTheme({
    typography: {
        button: {
            textTransform: 'none',
        },
        fontFamily: 'Porsche Next !important',
    },

    palette: {
        primary: {
            main: '#1C1C1C',
            contrastText: '#fff',
        },

        secondary: {
            main: '#D5001C',
            contrastText: '#fff',
        },
    },
});

export default basicTheme;
